import { APIClient } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { ProductEquipmentsResponse } from '@frontend/equipment/types';

export class EquipmentProductClient extends APIClient {
    public static readonly endpoint = '/equipment-api/v1';

    public static async postGetLendEquipments(ids: string[], withCredentials?: Token): Promise<ProductEquipmentsResponse> {
        const response = await this.post(`${this.endpoint}/lend-equipments`, { ids: ids }, true, withCredentials);
        return await this.handleResponse<ProductEquipmentsResponse>(response);
    }
}
